/* eslint-disable object-shorthand */
import { useSelector } from 'react-redux';
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';
import { useFetchPosProfileDetails } from '@/services/hooks';
import { FilterType } from '@/pages/SalesReport';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetcher = ({ queryKey }: any) => {
  const url = queryKey[1];
  const posProfile = queryKey[2];
  const filterValues = queryKey[3];

  const response = axios
    .get(
      `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.reports.reports.get_payment_report?pos_profile=${posProfile}&from_date=${filterValues.fromDate}&to_date=${filterValues.toDate}&from_time=${filterValues.fromTime}&to_time=${filterValues.toTime}&company=${filterValues.company}&cost_center=${filterValues.costCenter}&mode_of_payment=${filterValues.paymentMode}&payment_detail=${filterValues.paymentDetail}&cashier=${filterValues.cashier}`,
      {
        withCredentials: true,
      },
    )
    .then((data) => data?.data)
    .catch((error) => error.response.message);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useFetchSalesReport = (filter: FilterType) => {
  const { url } = useSelector(selectAuth);
  const { data: posProfile } = useFetchPosProfileDetails();

  return useQuery(['sales-report', url, posProfile?.company, filter], fetcher, {
    enabled: !!posProfile,
  });
};
